import React, { useState } from 'react';
import './MentionGuide.css';

const MentionGuide = () => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="mention-guide-container">
      <button 
        className="mention-guide-toggle"
        onClick={() => setIsVisible(!isVisible)}
        title="How to use @mentions"
      >
        ?
      </button>
      
      {isVisible && (
        <div className="mention-guide-dropdown">
          <div className="mention-guide-content">
            <h4>How to use @mentions</h4>
            <div className="mention-guide-tips">
              <div className="mention-tip">
                <strong>Type @username</strong> to mention someone
              </div>
              <div className="mention-tip">
                <strong>Example:</strong> <span className="mention-example">@john</span> mentions the user "john@company.com"
              </div>
              <div className="mention-tip">
                <strong>Notifications:</strong> Mentioned users will receive notifications
              </div>
              <div className="mention-tip">
                <strong>Usernames:</strong> Use the part before @ in email addresses
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MentionGuide;